import { useLocation } from 'react-router-dom';
import { ADMIN_BASE_PATH } from '@/config/admin-routes';

const ICP_RECORD_NUMBER = '粤ICP备2026106748号';

export default function IcpFooter() {
  const { pathname } = useLocation();

  if (pathname.startsWith(ADMIN_BASE_PATH)) {
    return null;
  }

  return (
    <footer className="border-t border-orange-100 bg-[#fffaf5] px-4 py-4 text-center text-xs text-stone-500">
      <a
        className="transition-colors hover:text-orange-600"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noreferrer"
      >
        {ICP_RECORD_NUMBER}
      </a>
    </footer>
  );
}
